export default __webpack_public_path__ + "static/media/menu.94977e84.svg";